module.exports = __webpack_public_path__ + "media/32.29715642.mp3";